import objectPath from "object-path";
import { useClassesStore } from "@/core/store/config/classesStore";

const HtmlClass = {
  config: null,

  init(config) {
    if (typeof config !== "undefined") {
      this.config = config;
    }

    // init base layout
    this.initLayout();

    // init header and subheader menu
    this.initHeader();
    this.initSubheader();

    // init aside and aside menu
    this.initAside();
  },

  /**
   * Init Layout
   */
  initLayout() {
    const classesStore = useClassesStore();
    // Offcanvas directions
    classesStore.addBodyClassname("quick-panel-right");
    classesStore.addBodyClassname("demo-panel-right");
    classesStore.addBodyClassname("offcanvas-right");

    // Properly close mobile header menu
    classesStore.removeBodyClassname("header-menu-wrapper-on");
  },

  /**
   * Init Header
   */
  initHeader() {
    const classesStore = useClassesStore();
    // Fixed header
    classesStore.addBodyClassname("header-fixed");
    classesStore.setClassnameByPosition({
      position: "header",
      className: "header-fixed",
    });

    classesStore.addBodyClassname("header-mobile-fixed");
    classesStore.setClassnameByPosition({
      position: "header_mobile",
      className: "header-mobile-fixed",
    });

    if (objectPath.get(this.config, "header.menu.self.display")) {
      classesStore.setClassnameByPosition({
        position: "header_menu",
        className: "header-menu-layout-default",
      });
    }
  },

  /**
   * Init Subheader
   */
  initSubheader() {
    const classesStore = useClassesStore();
    if (objectPath.get(this.config, "subheader.display")) {
      classesStore.addBodyClassname("subheader-enabled");
    }

    classesStore.addBodyClassname("subheader-transparent");
  },

  /**
   * Init Aside
   */
  initAside() {
    const classesStore = useClassesStore();
    // Reset aside class in body
    classesStore.removeBodyClassname("aside-enabled");
    classesStore.removeBodyClassname("aside-fixed");
    classesStore.removeBodyClassname("aside-static");
    classesStore.removeBodyClassname("aside-minimize");

    if (objectPath.get(this.config, "aside.self.display") !== true) {
      return;
    }

    // Add aside class enabled in body
    classesStore.addBodyClassname("aside-enabled");

    // Fixed Aside
    classesStore.addBodyClassname("aside-static");
  },
};

export default HtmlClass;
